import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ParamConfig} from "../../../interfaces/params";
import {ReportParamsStore} from '../../../store/report/report-params.store';
import {ReportStore} from '../../../store/report/report.store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-report-params',
  templateUrl: './report-params.component.html',
  styleUrls: ['./report-params.component.scss'],
  providers: []
})
export class ReportParamsComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public actionsConfigs: Array<ParamConfig>;
  @Input() public paramsConfigs: Array<ParamConfig>;
  @Input() public paramsDropdownConfigs: Array<ParamConfig>;
  @Input() public autoSubmit: boolean = false;

  @Output() public onReady: EventEmitter<void> = new EventEmitter<void>();

  public paramsDef: Array<ParamConfig> = [];
  public paramsDropdownDef: Array<ParamConfig> = [];
  public actionsDef: Array<ParamConfig> = [];

  public readonly form: FormGroup = this._reportParamsStore.form;
  public readonly publicMode$: Observable<boolean> = this._reportStore.publicMode$;

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _reportParamsStore: ReportParamsStore,
    private readonly _injector: Injector
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // TODO à refacto

    this.paramsDef = this.paramsConfigs.map((param: ParamConfig): ParamConfig => {
      if (!this._reportParamsStore.form.contains(param.controlName)) {
        param.control = new FormControl(null, [Validators.required]);
        this._reportParamsStore.form.addControl(param.controlName, param.control);
      }

      param.form = this._reportParamsStore.form;
      param.injector = Injector.create({ providers: [{ provide: 'paramDef', useValue: param }], parent: this._injector });

      return param;
    });

    this.paramsDropdownDef = this.paramsDropdownConfigs.map((param: ParamConfig): ParamConfig => {
      if ('controlName' in param && !this._reportParamsStore.form.contains(param.controlName)) {
        param.control = new FormControl(null, [Validators.required]);
        this._reportParamsStore.form.addControl(param.controlName, param.control);
      }

      param.form = this._reportParamsStore.form;
      param.injector = Injector.create({ providers: [{ provide: 'paramDef', useValue: param }], parent: this._injector });

      return param;
    });

    this.actionsDef = this.actionsConfigs.map((param: ParamConfig): ParamConfig => {
      if ('controlName' in param && !this._reportParamsStore.form.contains(param.controlName)) {
        param.control = new FormControl(null, [Validators.required]);
        this._reportParamsStore.form.addControl(param.controlName, param.control);
      }

      return param;
    });

    this.onReady.emit();

    this._reportParamsStore.init();
  }

  ngOnDestroy(): void {}

  public submit(): void {
    this._reportParamsStore.submit();
  }

}
